module.exports = __webpack_public_path__ + "static/img/completed.fadb91c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/image/activityManage/completed.svg
// module id = pQF6
// module chunks = 1